function debounce(fn, wait) {
  let t
  return (...args) => {
    clearTimeout(t)
    t = setTimeout(() => fn.apply(this, args), wait)
  }
}
class PredictiveSearch extends HTMLElement {
  constructor() {
    super()
    this.cachedResults = {}
    this.input = this.querySelector('input[type="search"]')
    this.predictiveSearchResults = this.querySelector(
      '[data-predictive-search]',
    )
    this.isOpen = false

    // Drop In Blog
    this.blogResultsContainer = document.createElement('div')
    this.dib_id = '0602e1db-ca8d-4d6c-9b24-ac31a893cea8'
    this.dib_url = 'https://api.dropinblog.com/v1/json/'
    this.dib_fetched = false
    this.dib_cached_posts = []

    this.setupEventListeners()
  }

  setupEventListeners() {
    const form = this.querySelector('form.search')
    form.addEventListener('submit', this.onFormSubmit.bind(this))

    this.input.addEventListener(
      'input',
      debounce((event) => {
        this.onChange(event)
      }, 300),
    )

    this.input.addEventListener('focus', this.onFocus.bind(this))
    this.addEventListener('focusout', this.onFocusOut.bind(this))
    this.addEventListener('keyup', this.onKeyup.bind(this))
    this.addEventListener('keydown', this.onKeydown.bind(this))
  }

  getQuery() {
    return this.input.value.trim()
  }

  onChange() {
    const searchTerm = this.getQuery()
    const noResultFound = document.querySelector(
      '#predictive-search-option-search-keywords',
    )
    const searchResultBox = document.querySelector('#predictive-search-results')

    if (searchTerm.length === 0) {
      noResultFound.style.display = 'none'
      searchResultBox.style.display = 'none'
    }

    if (!searchTerm.length) {
      this.close(true)
      return
    }

    if (!this.dib_fetched) {
      this.getPosts(searchTerm)
    }

    this.getPostsResults(searchTerm)
    this.getSearchResults(searchTerm)
  }

  onFormSubmit(event) {
    event.preventDefault()
    if (!this.getQuery().length || this.querySelector('[aria-selected="true"]'))
      event.preventDefault()
  }

  onFocus() {
    const searchTerm = this.getQuery()

    if (!searchTerm.length) return

    if (this.getAttribute('results') === 'true') {
      this.open()
    } else {
      this.getSearchResults(searchTerm)
    }
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close()
    })
  }

  onKeyup(event) {
    if (!this.getQuery().length) this.close(true)
    event.preventDefault()

    switch (event.code) {
      case 'ArrowUp':
        this.switchOption('up')
        break
      case 'ArrowDown':
        this.switchOption('down')
        break
      case 'Enter':
        this.selectOption()
        break
    }
  }

  onKeydown(event) {
    // Prevent the cursor from moving in the input when using the up and down arrow keys
    if (event.code === 'ArrowUp' || event.code === 'ArrowDown') {
      event.preventDefault()
    }
  }

  switchOption(direction) {
    if (!this.getAttribute('open')) return

    const moveUp = direction === 'up'
    const selectedElement = this.querySelector('[aria-selected="true"]')
    const allElements = this.querySelectorAll('li')
    let activeElement = this.querySelector('li')

    if (moveUp && !selectedElement) return

    this.statusElement.textContent = ''

    if (!moveUp && selectedElement) {
      activeElement = selectedElement.nextElementSibling || allElements[0]
    } else if (moveUp) {
      activeElement =
        selectedElement.previousElementSibling ||
        allElements[allElements.length - 1]
    }

    if (activeElement === selectedElement) return

    activeElement.setAttribute('aria-selected', true)
    if (selectedElement) selectedElement.setAttribute('aria-selected', false)

    this.setLiveRegionText(activeElement.textContent)
    this.input.setAttribute('aria-activedescendant', activeElement.id)
  }

  selectOption() {
    const selectedProduct = this.querySelector(
      '[aria-selected="true"] a, [aria-selected="true"] button',
    )

    if (selectedProduct) selectedProduct.click()
  }

  getPosts(searchTerm) {
    fetch(`${this.dib_url}?b=${this.dib_id}&limit=1000`)
      .then((response) => response.json())
      .then((response) => {
        this.dib_fetched = true
        this.dib_cached_posts = response.data.posts
        this.getPostsResults(searchTerm)
      })
  }

  getPostsResults(searchTerm) {
    const queryKey = searchTerm.replace(' ', '-').toLowerCase()
    const results = this.dib_cached_posts.filter((post) => {
      return post.title.toLowerCase().includes(queryKey)
    })
    this.renderPostResults(results, searchTerm)
  }

  renderPostResults(posts, searchTerm) {
    this.blogResultsContainer.innerHTML = ''

    if (posts.length === 0) {
      this.blogResultsContainer.innerHTML = `
        <div class="post-no-results">
          <p>No stories found for ${searchTerm}.</p>
        </div>
      `
    } else {
      this.blogResultsContainer.innerHTML = `
        <div class="search_criteria-header">
          <h3>Stories <span>${posts.length}</span></h3>
        </div>
      `
    }

    posts.forEach((post) => {
      const listItem = document.createElement('li')
      listItem.classList.add('search__post__result')
      listItem.innerHTML = `
        <a href="/a/blog/${post.slug}" class="post" id="${post.slug}">
          <figure>
            <img src="${post.featuredImage}" />
          </figure>
          <div class="content">
            <small>${post.publishedAt}</small>
            <h4>${post.title}</h4>
            <p>${post.summary}</p>
          </div>
          <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M10.0312 0L7.60935 2.35478L14.1059 8.67132H0V11.9966H14.1059L7.60935 18.3132L10.0312 20.668L20.668 10.3419L10.0312 0Z" fill="white"></path>
          </svg>
        </a>
      `
      this.blogResultsContainer.appendChild(listItem)
    })
  }

  getSearchResults(searchTerm) {
    const queryKey = searchTerm.replace(' ', '-').toLowerCase()
    this.setLiveRegionLoadingState()
    if (this.cachedResults[queryKey]) {
      this.renderSearchResults(this.cachedResults[queryKey])
      return
    }

    fetch(
      `${routes.predictive_search_url}?q=${encodeURIComponent(searchTerm)}&${encodeURIComponent('resources[type]')}=product&${encodeURIComponent('resources[limit]')}=20&resources[options][fields]=title,tag&resources[product]=title&options[unavailable_products]=hide&section_id=predictive-search&options[prefix]=last`,
    )
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status)
          this.close()
          throw error
        }
        console.log(response)
        return response.text()
      })
      .then((text) => {
        const resultsMarkup = new DOMParser()
          .parseFromString(text, 'text/html')
          .querySelector('#shopify-section-predictive-search').innerHTML
        this.cachedResults[queryKey] = resultsMarkup
        this.renderSearchResults(resultsMarkup)
      })
      .catch((error) => {
        this.close()
        throw error
      })
  }

  setLiveRegionLoadingState() {
    this.statusElement =
      this.statusElement || this.querySelector('.predictive-search-status')
    this.loadingText =
      this.loadingText || this.getAttribute('data-loading-text')
    this.setLiveRegionText(this.loadingText)
    this.setAttribute('loading', true)
  }

  setLiveRegionText(statusText) {
    this.statusElement.setAttribute('aria-hidden', 'false')
    this.statusElement.textContent = statusText

    setTimeout(() => {
      this.statusElement.setAttribute('aria-hidden', 'true')
    }, 1000)
  }

  renderSearchResults(resultsMarkup) {
    this.predictiveSearchResults.innerHTML = resultsMarkup
    this.predictiveSearchResults.querySelector(
      '#blog-search-results-list',
    ).innerHTML = this.blogResultsContainer.innerHTML
    this.setAttribute('results', true)

    this.setLiveRegionResults()
    this.open()
  }

  setLiveRegionResults() {
    this.removeAttribute('loading')
    this.setLiveRegionText(
      this.querySelector('[data-predictive-search-live-region-count-value]')
        .textContent,
    )
  }

  getResultsMaxHeight() {
    this.resultsMaxHeight =
      window.innerHeight -
      document.getElementById('shopify-section-header').getBoundingClientRect()
        .bottom
    return this.resultsMaxHeight
  }

  open() {
    this.predictiveSearchResults.style.maxHeight =
      this.resultsMaxHeight || `${this.getResultsMaxHeight()}px`
    this.setAttribute('open', true)
    this.input.setAttribute('aria-expanded', true)
    this.isOpen = true
  }

  close(clearSearchTerm = false) {
    if (clearSearchTerm === 'true') {
      this.input.value = ''
      this.removeAttribute('results')
    }

    const selected = this.querySelector('[aria-selected="true"]')

    if (selected) selected.setAttribute('aria-selected', false)

    this.input.setAttribute('aria-activedescendant', '')
    this.removeAttribute('open')
    this.input.setAttribute('aria-expanded', false)
    this.resultsMaxHeight = false
    this.predictiveSearchResults.removeAttribute('style')

    this.isOpen = false
  }
}

customElements.define('predictive-search', PredictiveSearch)
